var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('PersonaForm',{attrs:{"user":_vm.user,"persona":_vm.persona,"provincias":_vm.provincias,"isUpdate":false},on:{"process-persona":_vm.processPersona,"close-dialog":function($event){return _vm.$emit('close-dialog')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }